var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "377px",
    height: "450px",
    viewBox: "0 0 377 450",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AC580875-738D-403C-838D-ACD2D866046A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HomeKeep---Walkthrough",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Catalog-1-2",
    transform: "translate(12.000000, -75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "catalog-illustration",
    transform: "translate(-11.289166, 75.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.51817,354.605344 C273.589425,422.87075 356.527899,366.267584 356.983274,274.065249 C357.435899,181.862915 245.320187,41.8414452 197.863495,133.318301 C150.406803,224.795157 35.5068134,135.519225 22.2352466,194.083299 C8.96367978,252.647372 33.4469144,286.339939 153.51817,354.605344 Z",
    id: "Oval",
    fill: "#00D2B7",
    opacity: 0.103015988,
    transform: "translate(187.991637, 244.146939) rotate(-71.000000) translate(-187.991637, -244.146939) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "avid-humans2-02",
    transform: "translate(122.289166, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero",
    points: "69.6696833 412.357798 73 395 57 395 57 417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.611082,406.404494 C71.611082,406.404494 72.840255,429.578652 70.9282081,429.859551 C70.3136216,429.929775 64.577481,430 57.4073053,430 C43.2035287,430 23.0587492,429.859551 23.0587492,429.859551 C23.0587492,429.859551 21.966151,420.308989 29.2046141,420.589888 C57.7487423,421.643258 54.7440972,405 54.7440972,405 L71.611082,406.404494 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5738519,414 C60.5738519,414 60.5738519,414 60.5738519,414 L53.2900014,412.051957 C53.0857813,412.051957 52.9496345,411.744371 53.0177079,411.436785 C53.0177079,411.129199 53.221928,410.924142 53.4261481,411.026671 L60.7099986,412.974714 C60.9142187,412.974714 61.0503655,413.2823 60.9822921,413.589886 C60.9142187,413.897471 60.778072,414 60.5738519,414 Z",
    id: "Path",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5738519,417 C58.5738519,417 58.5738519,417 58.5738519,417 L51.2900014,415.051957 C51.0857813,415.051957 50.9496345,414.744371 51.0177079,414.436785 C51.0177079,414.129199 51.221928,413.924142 51.4261481,414.026671 L58.7099986,415.974714 C58.9142187,415.974714 59.0503655,416.2823 58.9822921,416.589886 C58.9142187,416.897471 58.778072,417 58.5738519,417 Z",
    id: "Path-Copy-3",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5738519,420 C54.5738519,420 54.5738519,420 54.5738519,420 L47.2900014,418.051957 C47.0857813,418.051957 46.9496345,417.744371 47.0177079,417.436785 C47.0177079,417.129199 47.221928,416.924142 47.4261481,417.026671 L54.7099986,418.974714 C54.9142187,418.974714 55.0503655,419.2823 54.9822921,419.589886 C54.9142187,419.897471 54.778072,420 54.5738519,420 Z",
    id: "Path-Copy-4",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero",
    points: "114.387387 412.357798 111 395 127 395 127 417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.388918,406.404494 C111.388918,406.404494 110.159745,429.578652 112.071792,429.859551 C112.686378,429.929775 118.422519,430 125.592695,430 C139.796471,430 159.941251,429.859551 159.941251,429.859551 C159.941251,429.859551 161.033849,420.308989 153.795386,420.589888 C125.251258,421.643258 128.255903,405 128.255903,405 L111.388918,406.404494 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.272217,428.966003 C111.339727,430.046003 111.734239,430.859551 112.071792,430.859551 C113.962087,431.147551 160,431 160,431 C160,431 160.084106,430.046003 160.084106,428.966003 C152.387904,429.038003 117.483187,429.182003 111.272217,428.966003 Z",
    id: "Path",
    fill: "#AA4E4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7004395,429 C71.6329289,430.08 71.2204263,430.872 70.8828735,430.872 C68.9925782,431.16 23,431 23,431 C23,431 23,430.08 23,429 C30.6962025,429.072 65.489469,429.144 71.7004395,429 Z",
    id: "Path",
    fill: "#AA4E4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.34188,415 C122.205128,415 122.068376,414.794943 122,414.589886 C122,414.2823 122.068376,414.077243 122.273504,413.974714 L129.589744,412.026671 C129.794872,411.924142 129.931624,412.129199 130,412.436785 C130,412.744371 129.931624,412.949428 129.726496,413.051957 L122.34188,415 C122.34188,415 122.34188,415 122.34188,415 Z",
    id: "Path",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34188,418 C126.205128,418 126.068376,417.794943 126,417.589886 C126,417.2823 126.068376,417.077243 126.273504,416.974714 L133.589744,415.026671 C133.794872,414.924142 133.931624,415.129199 134,415.436785 C134,415.744371 133.931624,415.949428 133.726496,416.051957 L126.34188,418 C126.34188,418 126.34188,418 126.34188,418 Z",
    id: "Path-Copy",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34188,421 C130.205128,421 130.068376,420.794943 130,420.589886 C130,420.2823 130.068376,420.077243 130.273504,419.974714 L137.589744,418.026671 C137.794872,417.924142 137.931624,418.129199 138,418.436785 C138,418.744371 137.931624,418.949428 137.726496,419.051957 L130.34188,421 C130.34188,421 130.34188,421 130.34188,421 Z",
    id: "Path-Copy-2",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero",
    points: "154.495968 84 165.943548 82.7780679 168 71.0339426 166.629032 59.154047 163.818548 58 161.762097 58.3394256 159.979839 58.2036554 156.895161 58.6109661 153.399194 59.2898172 153.961834 67.8455853 152.495665 67.461323 150.423952 63.1764975 148.289164 66.231908 151 76.3968668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.000937,166 C115.000937,166 135.890898,235.263158 131.355577,398.869883 C110.053314,398.732456 105.792862,398.869883 105.792862,398.869883 C105.792862,398.869883 103.319051,354.687135 100.295504,316.894737 C97.4781077,281.919591 78.7870902,246.394737 78.7870902,221.176901 C78.7870902,232.445906 81.8793541,268.864035 81.8793541,297.24269 C81.8793541,349.671053 78.7870902,401 78.7870902,401 L53.6366768,401 C53.6366768,401 22.9201884,245.226608 47.5895829,171.909357 C104.074937,167.78655 115.000937,166 115.000937,166 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-15",
    fill: "#1B1C1F",
    points: "117.808105 182.456055 99.800293 187.752441 43.8891602 182.456055"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-17",
    fill: "#1B1C1F",
    points: "65 266.900879 39.0527344 277.900879 38 266.900879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94176,83.2360019 L140.952611,125.571032 C135.74711,103.482629 132.190966,89.6256188 130.28418,84 C127.615592,76.1268271 124.308675,69.7356502 120.363428,64.8264692 C117.876144,60.2757982 109.930654,60 105.646999,60 C105.646999,60 105.577908,60 105.577908,60 L53.6904035,60 C49.1303832,60.2068487 44.5703628,61.9995373 42.3594439,63.0337807 C39.7339776,63.7922258 37.3848762,65.1022675 36.2103255,67.2397038 L5.32655137,135.36187 C4.2210919,137.085609 3.80654459,139.085146 4.08290946,141.084683 C4.98109529,147.428043 25.9848254,209 25.9848254,209 L40.0794337,208.034706 L26.6757375,137.706155 L43.3958121,104.403517 L43.3958121,182.297852 L123.645508,182.297852 L117.945236,124.123091 C126.305273,139.291994 135.839861,151.220268 145.167175,150.737621 C157.258138,150.117075 167,81.5812124 167,81.5812124 L153.94176,83.2360019 Z",
    id: "Path",
    fill: "#00D2B7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,69.3549805 C64.4257812,75.5935872 69.7327474,78.7128906 76.9208984,78.7128906 C84.1090495,78.7128906 89.9142253,75.8107096 94.3364258,70.0063477",
    id: "Path-16",
    stroke: "#03A994",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-14",
    fill: "#03A994",
    points: "117.945236 124.123091 120.279785 148.056641 111.871094 128.076172 108.137207 105.483887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20",
    fill: "#009C88",
    points: "153.94176 81.2360019 152.15918 86.9182129 166.244873 84.737793 167 79.5812124"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.703125,
    y1: 136.5,
    x2: 141.067383,
    y2: 125.390137,
    id: "Path-13-Copy",
    stroke: "#03A994",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 137.5,
    x2: 14.0673828,
    y2: 131.390137,
    id: "Path-13",
    stroke: "#03A994",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1B1C1F",
    strokeWidth: 5,
    strokeLinejoin: "round",
    x: 15,
    y: 0,
    width: 35,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11 L55,11 C60.5228475,11 65,15.4771525 65,21 L65,49 L65,49 L0,49 L0,21 C-6.76353751e-16,15.4771525 4.4771525,11 10,11 Z",
    id: "Rectangle",
    fill: "#AA4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B1C1F",
    x: 0,
    y: 22,
    width: 65,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#353A4D",
    x: 8,
    y: 30,
    width: 49,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#E7E7E7",
    x: 13,
    y: 34,
    width: 40,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    fill: "#E7E7E7",
    x: 13,
    y: 40,
    width: 40,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B1C1F",
    x: 8,
    y: 19,
    width: 7,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1B1C1F",
    x: 50,
    y: 19,
    width: 7,
    height: 8,
    rx: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero",
    points: "39.2851563 206.018188 24.8441162 204.738892 25.9246862 215.052846 28.7698745 222.447154 32.1129707 223 34.2468619 222.170732 36.2384937 221.963415 37.6610879 221.341463 40.5774059 221.203252 42 209.731707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy",
    fill: "#009C88",
    points: "23.2836914 202.128418 24.8441162 207.377441 40.8936768 208.883789 39.4920654 202.128418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7453416,233 C78.7453416,233 78.7453416,233 78.7453416,233 C78.2981366,233 78,232.65708 78,232.245575 L79.3416149,211.25885 C79.3416149,211.121681 79.4161491,210.915929 79.5652174,210.847345 L88.7329193,202.205752 C89.0310559,201.931416 89.4782609,201.931416 89.7763975,202.205752 C90.0745342,202.480088 90.0745342,202.891593 89.7763975,203.165929 L80.8322981,211.670354 L79.5652174,232.382743 C79.4906832,232.725664 79.1925466,233 78.7453416,233 Z",
    id: "Path",
    fill: "#1B1C1F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.302266,32.9860812 C104.982955,25.0019861 105.638107,16.7445398 101.765589,14.5425587 C97.8930719,12.3405777 90.9593283,17.0279073 86.2786397,25.0120025 C81.5979511,32.9960976 80.942799,41.253544 84.8153166,43.455525 C88.6878341,45.6575061 95.6215777,40.9701764 100.302266,32.9860812 Z",
    id: "Oval",
    fill: "#180D35",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8081728,26.559392 C64.1100712,34.9325781 78.94963,42.5117552 74.426342,42.944851 C64.6655627,43.9554079 50.9369869,30.6016198 53.6350885,22.1562511 C56.3331901,13.7108824 59.0312917,7.93627128 63.4752237,9.16337613 C67.9191558,10.390481 69.5062744,18.186206 66.8081728,26.559392 Z",
    id: "Path",
    fill: "#180D35",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,72 L78,72 C70.8010753,72 65,66.2571802 65,59.1305483 L65,31.8694517 C65,24.7428198 70.8010753,19 78,19 L78,19 C85.1989247,19 91,24.7428198 91,31.8694517 L91,59.1305483 C91,66.2571802 85.1989247,72 78,72 Z",
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,49.2930423 L91,60.4223633 C91,60.4223633 67.7086126,66.0613954 65.161689,51.124645 C62.6147653,36.1878946 91,49.2930423 91,49.2930423 Z",
    id: "Path",
    fill: "#CC674C",
    fillRule: "nonzero",
    transform: "translate(78.000000, 52.720802) scale(-1, 1) translate(-78.000000, -52.720802) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.290453,33.9990419 C59.290453,47.5102778 66.8601741,58.6114014 76.4737199,59.8529744 C77.0792976,59.9260081 77.6848753,59.9990419 78.290453,59.9990419 C88.8123653,59.9990419 97.290453,48.3866823 97.290453,33.9990419 C97.290453,19.6114014 88.8123653,7.99904185 78.290453,7.99904185 C67.7685406,7.99904185 59.290453,19.6114014 59.290453,33.9990419 Z",
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0207364,38.8943326 C62.7520464,38.3511474 62.2773716,36.0303793 62.074685,32.9125512 C62.0136826,31.9741809 62.3466687,29.1068467 62.074685,28.1030341 C60.8989583,23.763971 59.0154425,22.474558 56.7630533,23.1811949 C54.5106641,23.8878319 53.6378567,27.97818 54.8135834,32.3172432 C55.9893101,36.6563063 58.7683472,39.6009696 61.0207364,38.8943326 Z",
    id: "Oval",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8638763,29.9990419 C61.7015204,29.9990419 61.4579865,29.8408072 61.4579865,29.6825725 C60.8085628,26.1222922 59.8344273,25.0937668 59.1038257,24.9355321 C58.0485122,24.6190628 56.9931988,25.8058229 56.9931988,25.8058229 C56.8308428,25.9640575 56.587309,25.9640575 56.424953,25.8058229 C56.2625971,25.6475882 56.2625971,25.4102362 56.3437751,25.2520015 C56.424953,25.1728841 57.7238004,23.6696547 59.3473596,24.0652414 C60.7273849,24.4608281 61.7015204,26.2805269 62.2697661,29.4452205 C62.3509441,29.7616898 62.1885881,29.9990419 61.8638763,29.9990419 C61.9450543,29.9990419 61.9450543,29.9990419 61.8638763,29.9990419 Z",
    id: "Path",
    fill: "#B05D46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.362771,33.5375776 C103.964614,29.7669791 103.439926,26.0214791 101.190847,25.1717693 C98.9417678,24.3220594 95.8199783,26.6899075 94.218135,30.4605061 C92.6162917,34.2311046 93.14098,37.9766046 95.3900591,38.8263145 C97.6391382,39.6760243 100.760928,37.3081762 102.362771,33.5375776 Z",
    id: "Oval",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7246682,31.9990419 C95.7246682,31.9990419 95.6378251,31.9990419 95.6378251,31.9990419 C95.377296,31.9348743 95.290453,31.8065393 95.290453,31.6140367 C96.0720403,29.3681732 97.2009998,28.2131576 98.5036453,28.020655 C99.9799769,27.8281525 101.108936,28.983168 101.195779,29.0473355 C101.369465,29.1756706 101.282622,29.3681732 101.108936,29.4965082 C100.93525,29.6248433 100.674721,29.5606757 100.501035,29.4323407 C100.501035,29.4323407 99.6326047,28.5339953 98.6773313,28.6623303 C97.722058,28.7906654 96.7667846,29.8815134 96.0720403,31.8065393 C96.0720403,31.9348743 95.8983542,31.9990419 95.7246682,31.9990419 Z",
    id: "Path",
    fill: "#B05D46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.290453,15.3298286 C101.290453,20.5316311 94.1786757,27.9990419 88.1457526,27.9990419 C82.1128296,27.9990419 78.3143225,18.130917 62.8968526,19.8903502 C60.8858783,20.1198415 61.3327615,10.8636929 61.3327615,8.56878009 C61.3327615,4.9734166 75.4095818,0.0011054029 79.0591279,0.0011054029 C82.7086739,0.0011054029 89.5071497,-0.271992547 95.1676701,5.46528961 C97.7000081,7.98969375 101.290453,9.66904358 101.290453,15.3298286 Z",
    id: "Path",
    fill: "#180D35",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5243357,38.5492033 C58.2484882,25.7378663 62.6013795,16.5137037 62.7514792,18.1974794 C63.2017783,22.3703149 58.3235381,51.7265785 78.2867982,51.7265785 C94.7227154,51.7265785 92.0959706,32.106931 94.3474661,23.3952219 C94.9478649,21.1989927 98.3251082,24.2737135 96.9742109,38.2563728 C95.6233136,52.1658244 86.6173316,59.9990419 78.1366985,59.9990419 C68.0049687,59.9990419 60.7251333,50.6284639 59.5243357,38.5492033 Z",
    id: "Path",
    fill: "#180D35",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#E7E7E7",
    points: "105.704834 399.191895 104.559326 390.506104 132.365967 390.506104 132 399.191895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "#E7E7E7",
    points: "53 401.348145 51.6081543 392.506104 79.6113281 392.506104 78.9770508 401.348145"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.5028cd9ed4318b1cccb579ab9a1b538d.svg";
export { ForwardRef as ReactComponent };